import { FC } from 'react';
import { Grid, GridProps } from '@mui/system';

const CustomContainer: FC<GridProps> = ({ children, ...props }) => (
  <Grid boxSizing="border-box" container maxWidth="100%" minWidth={0} rowSpacing={6.5} width="100%" {...props}>
    {children}
  </Grid>
);

export const CustomCompactContainer: FC<GridProps> = ({ children, ...props }) => (
  <CustomContainer rowSpacing={5} {...props}>
    {children}
  </CustomContainer>
);

export default CustomContainer;
